var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProspectingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.03158 34.4919C13.5069 38.5015 30.17 36.3735 33.9283 25.5544C37.6866 14.7353 33.7941 8.84412 25.3188 4.85695C16.8434 0.869777 8.02288 -2.82619 4.28375 7.99293C0.544622 18.812 -3.44378 30.5048 5.03158 34.4919Z",
    fill: "#6FD78A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6588 8.9027C28.1611 2.85727 11.4865 0.728897 5.72854 10.326C-0.0293984 19.9231 2.63191 26.6466 10.1339 32.6702C17.6359 38.6938 25.5311 44.5206 31.2703 34.9187C37.0095 25.3168 43.1608 14.9263 35.6588 8.9027Z",
    fill: "#44ADA3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8122 14.1986L37.6133 12.8618",
    stroke: "#33447C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6776 19.0195L36.1348 20.9092",
    stroke: "#5C6996",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8584 7.666L28.9421 10.8008",
    stroke: "#5C6996",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.38691 21.976C3.29044 20.9913 4.53248 20.0166 4.97464 19.7266L5.73836 23.0583C5.11532 23.129 3.48338 22.9607 3.38691 21.976Z",
    fill: "white",
    stroke: "#33447C",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2748 13.4166C19.0038 12.5709 22.0688 8.91082 22.6384 7.66602C22.4245 10.2062 23.0556 14.2655 23.8503 16.783C24.6451 19.3006 26.4333 22.3077 27.2281 23.4966C25.9432 23.2588 22.9715 22.3625 21.3468 22.5315C19.5025 22.7234 17.4324 23.7821 14.8191 24.3437C11.6136 25.4067 6.19058 26.0813 5.33224 20.8112C4.39866 15.0791 13.867 15.0834 17.2748 13.4166Z",
    fill: "white",
    stroke: "#33447C",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9283 14.3922C28.6318 16.9045 28.9749 19.2511 28.97 21.0068C28.9676 21.8882 28.8774 22.5909 28.719 23.0828C28.5542 23.595 28.3607 23.7512 28.2431 23.7879C28.1256 23.8246 27.8828 23.8046 27.4806 23.4694C27.0945 23.1475 26.6568 22.6096 26.2008 21.8713C25.2926 20.4006 24.372 18.2343 23.6686 15.722C22.9651 13.2097 22.6221 10.8631 22.6269 9.10743C22.6293 8.22603 22.7196 7.52326 22.8779 7.03142C23.0428 6.51918 23.2362 6.36297 23.3538 6.32627C23.4714 6.28956 23.7142 6.30957 24.1163 6.6448C24.5025 6.96667 24.9401 7.50464 25.3961 8.24294C26.3043 9.71357 27.2249 11.8799 27.9283 14.3922Z",
    fill: "white",
    stroke: "#33447C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8125 13.9528C28.0665 11.7941 25.2094 12.397 23.874 12.9682C23.874 12.9682 23.0951 13.9491 23.874 16.1369C24.653 18.3247 25.4626 18.438 25.4626 18.438C26.8901 17.8424 29.5585 16.1115 28.8125 13.9528Z",
    fill: "white",
    stroke: "#33447C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.089 28.7326C11.4055 27.8016 11.1065 26.009 10.9747 25.4122C12.6138 24.8751 16.0033 24.011 16.0485 24.4885C16.105 25.0853 14.5085 28.5536 14.4803 29.9561C14.452 31.3586 16.5715 33.8651 15.1868 35.0289C13.802 36.1927 11.3999 34.641 10.439 32.8506C9.47814 31.0602 10.6933 29.8964 11.089 28.7326Z",
    fill: "white",
    stroke: "#33447C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProspectingIcon);
export default __webpack_public_path__ + "static/media/prospecting-icon.16a1b2c6b4956bc40bb89cf9b3c6ea1f.svg";
export { ForwardRef as ReactComponent };